/**
 * @description
 * Behavior for menu divider
 *
 * @specification
 * Adds role 'presentation' to 'root' slot.
 */
var menuDividerBehavior = function menuDividerBehavior() {
  return {
    attributes: {
      root: {
        role: 'presentation'
      }
    }
  };
};

export default menuDividerBehavior;